import apiPaths from '../api-paths.js';

export default {
  link({ personOriginalId, bankId, returnUrl, bankAccountOriginalId, type, additionalData }) {
    return axios.post(`${ apiPaths.API }/open-banking/link`, {
      personOriginalId,
      bankAccountOriginalId,
      bankId,
      returnUrl,
      type,
      additionalData
    });
  },
  getBankOperations({ bankOriginalId, year, month }) {
    return axios.get(`${ apiPaths.API }/open-banking/bank-operations/${ bankOriginalId }/${ year }/${ month }`);
  },
  import({
           file,
           targetBankAccountOriginalId,
         }) {
    const formData = new FormData();
    formData.append('file', file);

    if (targetBankAccountOriginalId) {
      formData.append('targetBankAccountOriginalId', targetBankAccountOriginalId);
    }

    return axios.post(`${ apiPaths.API }/open-banking/bank-operations/import`,
      formData,
      {
        'Content-Type': 'multipart/form-data',
      });
  },
  syncFizenOperations(
    {
      personOriginal,
    }) {
    return axios.post(`${ apiPaths.API }/open-banking/bank-operations/synchronize/fizen/${ personOriginal }`, {});
  },
  setManuallySettled(
    {
      id,
      comment,
    }) {
    return axios.post(`${ apiPaths.API }/open-banking/bank-operations/${ id }/settlement/manually`, { 'comment': comment });
  },
};
